import type { SVGProps } from 'react';

interface HeartIconProps extends SVGProps<SVGSVGElement> {
  fillColor?: string;
  width?: number | string;
  height?: number | string;
  className?: string;
  filled?: boolean;
}

const FILLED_PATH =
  'M10 18.35L8.55 17.05C6.86667 15.5333 5.475 14.225 4.375 13.125C3.275 12.025 2.4 11.0375 1.75 10.1625C1.1 9.2875 0.645833 8.48333 0.3875 7.75C0.129167 7.01667 0 6.26667 0 5.5C0 3.93333 0.525 2.625 1.575 1.575C2.625 0.525 3.93333 0 5.5 0C6.36667 0 7.19167 0.183333 7.975 0.55C8.75833 0.916667 9.43333 1.43333 10 2.1C10.5667 1.43333 11.2417 0.916667 12.025 0.55C12.8083 0.183333 13.6333 0 14.5 0C16.0667 0 17.375 0.525 18.425 1.575C19.475 2.625 20 3.93333 20 5.5C20 6.26667 19.8708 7.01667 19.6125 7.75C19.3542 8.48333 18.9 9.2875 18.25 10.1625C17.6 11.0375 16.725 12.025 15.625 13.125C14.525 14.225 13.1333 15.5333 11.45 17.05L10 18.35Z';

const OUTLINE_PATH =
  'M7.67857 13.7625L6.56518 12.7875C5.27262 11.65 4.20402 10.6688 3.35937 9.84375C2.51473 9.01875 1.84286 8.27813 1.34375 7.62188C0.844643 6.96563 0.495908 6.3625 0.297545 5.8125C0.0991816 5.2625 0 4.7 0 4.125C0 2.95 0.403125 1.96875 1.20937 1.18125C2.01562 0.39375 3.02024 0 4.22321 0C4.88869 0 5.52217 0.1375 6.12366 0.4125C6.72515 0.6875 7.24345 1.075 7.67857 1.575C8.11369 1.075 8.63199 0.6875 9.23348 0.4125C9.83497 0.1375 10.4685 0 11.1339 0C12.3369 0 13.3415 0.39375 14.1478 1.18125C14.954 1.96875 15.3571 2.95 15.3571 4.125C15.3571 4.7 15.258 5.2625 15.0596 5.8125C14.8612 6.3625 14.5125 6.96563 14.0134 7.62188C13.5143 8.27813 12.8424 9.01875 11.9978 9.84375C11.1531 10.6688 10.0845 11.65 8.79196 12.7875L7.67857 13.7625ZM7.67857 11.7375C8.90714 10.6625 9.91815 9.74063 10.7116 8.97188C11.5051 8.20313 12.1321 7.53438 12.5929 6.96563C13.0536 6.39688 13.3735 5.89063 13.5527 5.44688C13.7318 5.00313 13.8214 4.5625 13.8214 4.125C13.8214 3.375 13.5655 2.75 13.0536 2.25C12.5417 1.75 11.9018 1.5 11.1339 1.5C10.5324 1.5 9.97574 1.66563 9.46384 1.99688C8.95193 2.32813 8.6 2.75 8.40804 3.2625H6.94911C6.75714 2.75 6.40521 2.32813 5.8933 1.99688C5.3814 1.66563 4.8247 1.5 4.22321 1.5C3.45536 1.5 2.81548 1.75 2.30357 2.25C1.79167 2.75 1.53571 3.375 1.53571 4.125C1.53571 4.5625 1.6253 5.00313 1.80446 5.44688C1.98363 5.89063 2.30357 6.39688 2.76429 6.96563C3.225 7.53438 3.85208 8.20313 4.64554 8.97188C5.43899 9.74063 6.45 10.6625 7.67857 11.7375Z';

export const HeartIcon = ({
  fillColor = 'currentColor',
  width = 16,
  height = 16,
  className = '',
  filled = false,
  ...props
}: HeartIconProps) => {
  if (filled) {
    return (
      <svg
        width={width}
        height={height}
        viewBox='0 0 20 18.35'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        className={className}
        {...props}
      >
        <path
          d={FILLED_PATH}
          fill={fillColor}
        />
      </svg>
    );
  }

  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 15.357 13.7625'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
      {...props}
    >
      <path
        d={OUTLINE_PATH}
        fill={fillColor}
      />
    </svg>
  );
};

export default HeartIcon;
